import React from 'react';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

class RegisterConfirmed extends React.Component  {

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <CheckCircleOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Поздравляем
                    </Typography>
                    <br/>
                    <p>Регистрация на сайте <Link href="https://www.alaber.ru">www.alaber.ru</Link> подтверждена.</p>
                    <p>Вы сможете продолжить, когда перейдете в личный кабинет.</p>
                    <br />
                    <Link href="./" variant="body2">
                        Перейти в личный кабинет
                    </Link>
                </div>
            </Container>
        )

    }

}

export default RegisterConfirmed;